if (!customElements.get('quick-view')) {
class QuickView extends HTMLElement {
    constructor() {
        super();
        this.domParser = new DOMParser();
        this.quickAddButton = this.querySelector('#quick-add');
        if(document.querySelectorAll('.quick-view-wrap').length == 0){
            this.quickViewWrapper = document.createElement('div');
            this.quickViewWrapper.classList.add('quick-view-wrap');
            this.quickViewWrapperOverlay = document.createElement('div');
            this.quickViewWrapperOverlay.classList.add('quick-view-overlay');
            document.querySelector('body').appendChild(this.quickViewWrapper);
            document.querySelector('body').appendChild(this.quickViewWrapperOverlay);
        }
        else{
            this.quickViewWrapper = document.querySelector('.quick-view-wrap');
            this.quickViewWrapperOverlay = document.querySelector('.quick-view-overlay');
        }
        this.productUrl = this.getAttribute('data-product-url');
        if (this.quickAddButton) {
            this.quickAddButton.addEventListener('click', (event) => this.openQuickViewModal(event));
        }
    }
    async openQuickViewModal(event) {
        this.quickAddButton.classList.add('loading');
        const url = this.productUrl;
        try {
            const response = await fetch(url);
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            const html = await response.text();
      
            const newContent = this.domParser.parseFromString(html, 'text/html');
            const productData = newContent.querySelector('div.main-product');
            this.quickAddButton.classList.remove('loading');
            if (productData) {
                this.quickViewWrapper.innerHTML = productData.outerHTML;
                const newScriptTag = document.createElement('script');
                const closeButton = document.createElement('button');
                newScriptTag.setAttribute('src', productData.getAttribute('data-form-script'));
                this.quickViewWrapper.appendChild(newScriptTag);
                this.quickViewWrapperOverlay.classList.add('visible');
                this.quickViewWrapper.classList.add('visible');
                document.documentElement.style.overflow = 'hidden';
                closeButton.classList.add(['close-quick-view']);
                closeButton.innerHTML = `<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M22.5 8.8125L21.1875 7.5L15 13.6875L8.8125 7.5L7.5 8.8125L13.6875 15L7.5 21.1875L8.8125 22.5L15 16.3125L21.1875 22.5L22.5 21.1875L16.3125 15L22.5 8.8125Z" fill="black"/></svg>`;
                this.quickViewWrapper.appendChild(closeButton);
                closeButton.addEventListener('click', () => {
                    this.quickViewWrapperOverlay.classList.remove('visible');
                    this.quickViewWrapper.classList.remove('visible');
                    document.documentElement.style.overflow = 'auto';
                });
                this.quickViewWrapperOverlay.addEventListener('click', () => {
                    this.quickViewWrapperOverlay.classList.remove('visible');
                    this.quickViewWrapper.classList.remove('visible');
                    document.documentElement.style.overflow = 'auto';
                });
            }
        } catch (error) {
            this.quickAddButton.classList.remove('loading');
            console.error('Error:', error);
        }
    }
    
}
customElements.define('quick-view', QuickView);
}